/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Page_PrefixInputs */



/**
* | output |
* | --- |
* | "Page" |
*
* @param {Ccsl_Export_Page_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_page_prefix = /** @type {((inputs?: Ccsl_Export_Page_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Page_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Page ")
	if (locale === "de") return /** @type {LocalizedString} */ ("Seite ")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pagina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Страница ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Página")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("页 ")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ページ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पृष्ठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Página")
	return /** @type {LocalizedString} */ ("Page ")
});